export const TypeFilter = {
    DEFAULT: "string",
    TEXT: "text",
    NUMBER: "number",
    BOOLEAN: "boolean",
    DATE: "date",
};